"use client";

import Image from "next/image";
import styles from "./Footer.module.scss";

declare global {
  interface Window {
    OneTrust: any;
  }
}

interface ExecedFooterProps {
  customCss?: string;
  sectionId: string;
  backgroundColor?: string;
  linkColor: string;
  email: string;
  phoneNumber: string;
  image: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
  bottomLogos?: {
    src: string;
    alt: string;
    width: number;
    height: number;
  }[];
}

export const ExecedFooter = function ({
  customCss,
  sectionId,
  backgroundColor,
  linkColor,
  email,
  phoneNumber,
  image,
  bottomLogos,
}: ExecedFooterProps) {
  return (
    <>
      {customCss && <style>{customCss}</style>}
      <style>
        {`
          #${sectionId} {
            a {
              color: ${linkColor};
            }
          }
        `}
      </style>
      <footer className={`${styles.footerSection} footer`} id={sectionId} style={{ backgroundColor }}>
        <section className={styles.content}>
          <div className={styles.links}>
            <p>
              <a
                href=""
                target="_self"
                onClick={function (event) {
                  event.preventDefault();

                  if (typeof window.OneTrust === "undefined") {
                    console.error("Error: OneTrust is not defined");
                    return;
                  }

                  window.OneTrust.ToggleInfoDisplay();
                }}
              >
                Your Privacy Choices
              </a>
            </p>
            <span>
              Contact us:{" "}
              <a href={`mailto:${email}`} target="_blank">
                {email}
              </a>{" "}
              | <a href={`tel:${phoneNumber.replaceAll(" ", "")}`}>{phoneNumber}</a>
            </span>
            <span>
              GetSmarter and edX are owned by{" "}
              <a href="https://www.edx.org/" target="_blank">
                2U
              </a>
              .
            </span>
            <p className={styles.disclaimer}>
              Copyright ©2025 GetSmarter. All rights reserved |{" "}
              <a href="https://www.getsmarter.com/privacy-policy" target="_blank">
                Privacy Policy
              </a>{" "}
              |{" "}
              <a href="https://www.getsmarter.com/cookie-policy" target="_blank">
                Cookie policy
              </a>
            </p>
          </div>
          <div className={styles.logo}>
            <a href="https://www.getsmarter.com/" target="_blank">
              {image ? (
                <Image src={image.src} alt={image.alt} width={image.width} height={image.height} />
              ) : (
                <Image
                  src="https://www.getsmarter.com/presentations/wp-content/uploads/2024/04/GetSmarter_logo-lockup_with-edX_registered_rgb_color.svg"
                  alt="GetSmarter"
                  width={376}
                  height={35}
                />
              )}
            </a>
          </div>
        </section>
        {bottomLogos && (
          <section className={styles.bottomLogos}>
            <div className={styles.footerLogos}>
              <>
                <Image
                  src={bottomLogos[0].src}
                  alt={bottomLogos[0].alt}
                  width={bottomLogos[0].width}
                  height={bottomLogos[0].height}
                />
                <Image
                  src={bottomLogos[1].src}
                  alt={bottomLogos[1].alt}
                  width={bottomLogos[1].width}
                  height={bottomLogos[1].height}
                />
              </>
            </div>
          </section>
        )}
      </footer>
    </>
  );
};
